import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import Select from './Select';
import FieldContainer from './FieldContainer';

const useStyles = makeStyles((theme) =>
  createStyles({
    common: {
      background: 'white',
      fontFamily: theme.typography.fontFamily,
      color: '#8b8b8b',
      borderRadius: 4,
      '&:focus': {
        background: 'white',
      },
      '& div': {
        padding: '7px 10px',
        '&:focus': {
          background: 'white !important',
          borderRadius: 4,
        },
      },
      fontSize: 16,
      '&:hover': {
        backgroundColor: 'white',
        borderColor: 'rgba(0, 0, 0, 0.87)',
      },
    },
    textBlack: {
      '& div': { color: 'black' },
    },
    textGrey: {
      '& div': { color: '#8b8b8b' },
    },
    select: {
      border: `1px solid ${theme.palette.grey.A100}`,
    },
    selectRed: {
      border: '1px solid red !important',
    },
    themeColor: {
      color: theme.palette.error.main,
    },
    dropdownStyle: {
      border: '1px solid rgba(0, 0, 0, 0.23)',
      fontFamily: theme.typography.fontFamily,
      '& ul': {
        padding: 0,
        '& li': {
          fontSize: 16,
        },
      },
    },
  }),
);

const SelectDropdown: React.FC<any> = ({
  name,
  value,
  onChange,
  items,
  defaultValue,
  errorText,
  required,
  inputRef,
}) => {
  const classes = useStyles();
  return (
    <FieldContainer errorText={errorText}>
      <Select
        items={items}
        onChange={onChange}
        value={value}
        name={name}
        defaultValue={defaultValue}
        required={required}
        inputRef={inputRef}
        className={[
          classes.common,
          errorText ? classes.selectRed : classes.select,
          value === 0 ? classes.textGrey : classes.textBlack,
        ].join(' ')}
      />
    </FieldContainer>
  );
};

export default SelectDropdown;
